export default {"src":"/_next/static/media/stethoscope_64.cb558529.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};